import Backbone from 'backbone'
import icon from 'scoreboard/components/icon'
import template from './component-icon-test.hbs'

var ComponentIconTest = Backbone.View.extend({

	className: 'admin table-hack display-layout admin-test-view component-icon-test',

	events: {
		'submit .component-icon-test-form': 'test'
	},

	render: function () {
		this.$el.append(template())
		return this
	},

	test: function(e) {
		e.preventDefault()
		this.$('.test-content').removeClass('is-not-displayed')
		let iconText = this.$('input').val()
		let iconEl = icon(iconText, 'option-icon test-icon icon')
		this.$('.test-icon').replaceWith(iconEl)
	}

})

export default ComponentIconTest

